<script>
export default {
  name: "ArticleMeaningAntonym",
  props: {
    antonym: {
      type: String,
      required: true
    }
  }
};
</script>

<template>
  <div v-if="antonym" class="article-content__politiken-grid">
    <div class="article-content__text article-content__politiken-grid-label">Modsat:</div>
    <div class="article-content__politiken-grid-content">
      <span
        class="article-content__text article-content__text--primary pr-2"
        v-html="antonym"
      ></span>
    </div>
  </div>
</template>
